// extracted by mini-css-extract-plugin
export var numpadContainer = "_mn-1";
export var phoneButton = "_mn-0";